import { useRef } from 'react';

/**
 * For virtualized lists and tables: an onRowsRendered handler that loads the next page once one of the last
 * `threshold` rows is on screen. It asks at most once per list length, so a slow response can't trigger
 * duplicate requests, and a page that adds nothing doesn't loop. `resetKey` (e.g. the first row's id) starts
 * over when the list is replaced by a new one, like after a filter change.
 */
export function useLoadMoreNearEnd(length: number, hasNext: boolean | undefined, loadMore: () => void, resetKey?: any, threshold = 5) {
  const requestedAt = useRef(-1);
  const key = useRef(resetKey);
  if(key.current !== resetKey){
    key.current = resetKey;
    requestedAt.current = -1;
  }
  return ({stopIndex}: {stopIndex: number}) => {
    if(!hasNext || length == 0 || stopIndex < length - threshold || requestedAt.current == length)
      return;
    requestedAt.current = length;
    loadMore();
  };
}
